<template>
  <div id="app-root" :class="{ light: ui.isLightTheme }">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUiStore } from '@/stores/ui';
import { setDocumentLocale } from '@/i18n';
import { useDocumentSeo } from '@/composables/useDocumentSeo';
import type { LocaleCode } from '@/data/types';

const ui = useUiStore();
const { locale } = useI18n();

useDocumentSeo();

watch(
  locale,
  (value) => {
    setDocumentLocale(value as LocaleCode);
  },
  { immediate: true },
);
</script>
